export const webSocketConnectionEventName = 'WS_LINK_CONNECTION_STATUS_CHANGED';

export const errorMessages = {
  USER_IS_NOT_ACTIVE: 'Context creation failed: User is not active',
};
